import * as types from '../mutation-types'

// initial state
const state = {
  data: null
}

// mutations
const mutations = {
  [types.GET_EXTERIOR_DATA] (state, action) {
    state.data = action
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/exterior.js